// Fixed UI copy for the "Fin de Año 2026" landing (es / ca / en). Editable commercial texts live in the CMS (nye_page).
export const NYE_UI = {
  es: {
    downloadMenu: "Descargar el menú en PDF",
    banner: { eyebrow: "Fin de Año en el hotel · 31 · 12 · 2026", title: "Nochevieja 2026 · Reserva tu mesa", cta: "Ver menú y paquetes" },
    crumb: "Fin de Año 2026",
    dateLabel: "31 · 12 · 2026",
    countdown: { title: "Cuenta atrás para 2027", days: "días", hours: "horas", minutes: "min", seconds: "seg", done: "¡Feliz 2027!" },
    ctaPrimary: "Consultar disponibilidad y reservar",
    ctaMenu: "Ver menú de gala",
    ctaPackages: "Descubrir los paquetes",
    ctaAvailability: "Consultar disponibilidad",
    ctaInfo: "Solicitar información",
    introEyebrow: "La gran noche",
    pillarsEyebrow: "Una noche, cuatro razones",
    menuEyebrow: "Banquete de Gala · Nochevieja 2026",
    provisional: "Menú provisional · composición definitiva próximamente",
    pending: "Por confirmar",
    packagesEyebrow: "Paquetes",
    packagesTitle: "Elige cómo vivir la noche",
    packagesText: "Dos modalidades para celebrar la Nochevieja en el hotel: solo la cena de gala o la cena con alojamiento para despertar el 1 de enero sin desplazamientos.",
    priceTbc: "Precio por confirmar",
    includes: "Incluye",
    conditions: "Condiciones",
    howEyebrow: "Cómo funciona",
    contactEyebrow: "¿Prefieres hablar con nosotros?",
    call: "Llamar",
    write: "Escribir",
    whatsapp: "WhatsApp",
    faqTitle: "Preguntas frecuentes sobre Fin de Año",
    form: {
      eyebrow: "Solicitud de información y reservas",
      name: "Nombre y apellidos", email: "Correo electrónico", phone: "Teléfono de contacto",
      kind: "Tipo de solicitud",
      kinds: { informacion: "Solicitar información", disponibilidad: "Consultar disponibilidad", reserva: "Solicitar una reserva" },
      package: "Paquete de interés",
      packages: { cena: "Cena de Gala", cena_alojamiento: "Cena de Gala + Alojamiento", otro: "Otro / Todavía no lo sé" },
      adults: "Número de adultos", children: "Número de niños (si corresponde)", rooms: "Número de habitaciones (si corresponde)",
      message: "Observaciones o peticiones especiales",
      messagePlaceholder: "Alergias, intolerancias, horarios, celebraciones especiales…",
      select: "Selecciona…",
      consentBefore: "He leído y acepto la", privacy: "política de privacidad", and: "y el", legal: "aviso legal",
      consentAfter: ", y el tratamiento de mis datos para atender esta solicitud.",
      marketing: "Quiero recibir comunicaciones comerciales del Hotel Ciutat Martorell (opcional).",
      submit: "Enviar solicitud", sending: "Enviando…",
      required: "Campo obligatorio", invalidEmail: "Introduce un email válido", invalidPhone: "Introduce un teléfono válido",
      consentRequired: "Debes aceptar la política de privacidad para enviar la solicitud",
      notice: "Enviar este formulario no supone una reserva confirmada. El hotel se pondrá en contacto contigo para confirmar disponibilidad, condiciones y reserva.",
      successTitle: "Solicitud enviada",
      successText: "Hemos recibido tu solicitud y te hemos enviado una copia por email. Importante: todavía no es una reserva confirmada. Te contactaremos lo antes posible para confirmar disponibilidad, condiciones y reserva.",
      error: "No se pudo enviar la solicitud. Inténtalo de nuevo o llámanos.",
    },
  },
  ca: {
    downloadMenu: "Descarregar el menú en PDF",
    banner: { eyebrow: "Cap d'Any a l'hotel · 31 · 12 · 2026", title: "Cap d'Any 2026 · Reserva la teva taula", cta: "Veure menú i paquets" },
    crumb: "Cap d'Any 2026",
    dateLabel: "31 · 12 · 2026",
    countdown: { title: "Compte enrere per al 2027", days: "dies", hours: "hores", minutes: "min", seconds: "seg", done: "Feliç 2027!" },
    ctaPrimary: "Consultar disponibilitat i reservar",
    ctaMenu: "Veure menú de gala",
    ctaPackages: "Descobrir els paquets",
    ctaAvailability: "Consultar disponibilitat",
    ctaInfo: "Sol·licitar informació",
    introEyebrow: "La gran nit",
    pillarsEyebrow: "Una nit, quatre raons",
    menuEyebrow: "Banquet de Gala · Cap d'Any 2026",
    provisional: "Menú provisional · composició definitiva properament",
    pending: "Per confirmar",
    packagesEyebrow: "Paquets",
    packagesTitle: "Tria com viure la nit",
    packagesText: "Dues modalitats per celebrar el Cap d'Any a l'hotel: només el sopar de gala o el sopar amb allotjament per despertar l'1 de gener sense desplaçaments.",
    priceTbc: "Preu per confirmar",
    includes: "Inclou",
    conditions: "Condicions",
    howEyebrow: "Com funciona",
    contactEyebrow: "Prefereixes parlar amb nosaltres?",
    call: "Trucar",
    write: "Escriure",
    whatsapp: "WhatsApp",
    faqTitle: "Preguntes freqüents sobre Cap d'Any",
    form: {
      eyebrow: "Sol·licitud d'informació i reserves",
      name: "Nom i cognoms", email: "Correu electrònic", phone: "Telèfon de contacte",
      kind: "Tipus de sol·licitud",
      kinds: { informacion: "Sol·licitar informació", disponibilidad: "Consultar disponibilitat", reserva: "Sol·licitar una reserva" },
      package: "Paquet d'interès",
      packages: { cena: "Sopar de Gala", cena_alojamiento: "Sopar de Gala + Allotjament", otro: "Altres / Encara no ho sé" },
      adults: "Nombre d'adults", children: "Nombre de nens (si escau)", rooms: "Nombre d'habitacions (si escau)",
      message: "Observacions o peticions especials",
      messagePlaceholder: "Al·lèrgies, intoleràncies, horaris, celebracions especials…",
      select: "Selecciona…",
      consentBefore: "He llegit i accepto la", privacy: "política de privacitat", and: "i l'", legal: "avís legal",
      consentAfter: ", i el tractament de les meves dades per atendre aquesta sol·licitud.",
      marketing: "Vull rebre comunicacions comercials de l'Hotel Ciutat Martorell (opcional).",
      submit: "Enviar sol·licitud", sending: "Enviant…",
      required: "Camp obligatori", invalidEmail: "Introdueix un email vàlid", invalidPhone: "Introdueix un telèfon vàlid",
      consentRequired: "Has d'acceptar la política de privacitat per enviar la sol·licitud",
      notice: "Enviar aquest formulari no suposa una reserva confirmada. L'hotel es posarà en contacte amb tu per confirmar disponibilitat, condicions i reserva.",
      successTitle: "Sol·licitud enviada",
      successText: "Hem rebut la teva sol·licitud i t'hem enviat una còpia per email. Important: encara no és una reserva confirmada. Et contactarem al més aviat possible per confirmar disponibilitat, condicions i reserva.",
      error: "No s'ha pogut enviar la sol·licitud. Torna-ho a provar o truca'ns.",
    },
  },
  en: {
    downloadMenu: "Download the menu (PDF)",
    banner: { eyebrow: "New Year's Eve at the hotel · 31 · 12 · 2026", title: "New Year's Eve 2026 · Book your table", cta: "See menu and packages" },
    crumb: "New Year's Eve 2026",
    dateLabel: "31 · 12 · 2026",
    countdown: { title: "Countdown to 2027", days: "days", hours: "hours", minutes: "min", seconds: "sec", done: "Happy 2027!" },
    ctaPrimary: "Check availability and book",
    ctaMenu: "See the gala menu",
    ctaPackages: "Discover the packages",
    ctaAvailability: "Check availability",
    ctaInfo: "Request information",
    introEyebrow: "The big night",
    pillarsEyebrow: "One night, four reasons",
    menuEyebrow: "Gala Banquet · New Year's Eve 2026",
    provisional: "Provisional menu · final composition coming soon",
    pending: "To be confirmed",
    packagesEyebrow: "Packages",
    packagesTitle: "Choose how to live the night",
    packagesText: "Two ways to celebrate New Year's Eve at the hotel: the gala dinner only, or dinner plus accommodation so you can wake up on 1 January with no travel.",
    priceTbc: "Price to be confirmed",
    includes: "Includes",
    conditions: "Terms",
    howEyebrow: "How it works",
    contactEyebrow: "Prefer to talk to us?",
    call: "Call",
    write: "Email",
    whatsapp: "WhatsApp",
    faqTitle: "New Year's Eve FAQs",
    form: {
      eyebrow: "Information and booking requests",
      name: "Full name", email: "Email address", phone: "Contact phone",
      kind: "Type of request",
      kinds: { informacion: "Request information", disponibilidad: "Check availability", reserva: "Request a booking" },
      package: "Package of interest",
      packages: { cena: "Gala Dinner", cena_alojamiento: "Gala Dinner + Accommodation", otro: "Other / Not sure yet" },
      adults: "Number of adults", children: "Number of children (if applicable)", rooms: "Number of rooms (if applicable)",
      message: "Notes or special requests",
      messagePlaceholder: "Allergies, intolerances, timings, special celebrations…",
      select: "Select…",
      consentBefore: "I have read and accept the", privacy: "privacy policy", and: "and the", legal: "legal notice",
      consentAfter: ", and the processing of my data to handle this request.",
      marketing: "I would like to receive commercial communications from Hotel Ciutat Martorell (optional).",
      submit: "Send request", sending: "Sending…",
      required: "Required field", invalidEmail: "Enter a valid email", invalidPhone: "Enter a valid phone number",
      consentRequired: "You must accept the privacy policy to send the request",
      notice: "Submitting this form is not a confirmed booking. The hotel will contact you to confirm availability, terms and your booking.",
      successTitle: "Request sent",
      successText: "We have received your request and emailed you a copy. Important: this is not a confirmed booking yet. We will contact you as soon as possible to confirm availability, terms and your booking.",
      error: "The request could not be sent. Please try again or call us.",
    },
  },
};

export const NYE_TARGET = new Date("2026-12-31T23:59:59+01:00");
